import React from 'react';

const Message = () => {
    return (
        <div>
            this is message
        </div>
    );
};

export default Message;